/**
 * Shared geometry defaults for the rower side-view prototype.
 *
 * Coordinate frame:
 * - Origin sits on the waterline directly beneath the gate pivot at neutral seat.
 * - +X points toward the bow (seat moves positive X on the drive).
 * - +Y points up from the waterline.
 * - +Z points toward the camera (right-handed frame for Three.js).
 */
export interface RowerSideViewGeometry {
  scale: {
    metersPerUnit: number;
  };
  waterline: {
    y: number;
  };
  seat: {
    travelRange: number;
    neutralOffsetX: number;
    visualWidth: number;
    visualHeight: number;
    y: number;
  };
  oar: {
    length: number;
    pivotOffsetX: number;
    pivotHeightY: number;
    shaftRadius: number;
    bladeLength: number;
    bladeWidth: number;
  };
  boat: {
    hullLength: number;
    hullDepth: number;
    hullThickness: number;
    hullOffsetY: number;
  };
  crew: {
    seats: number;
    seatSpacing: number;
  };
  camera: {
    initialDistance: number;
    minPolarAngle: number;
    maxPolarAngle: number;
    minAzimuthAngle: number;
    maxAzimuthAngle: number;
    minDistance: number;
    maxDistance: number;
  };
}

export const rowerSideViewGeometry: RowerSideViewGeometry = {
  scale: {
    metersPerUnit: 1,
  },
  waterline: {
    y: 0,
  },
  seat: {
    travelRange: 0.8,
    neutralOffsetX: 0,
    visualWidth: 0.45,
    visualHeight: 0.1,
    y: 0.1,
  },
  oar: {
    length: 3,
    pivotOffsetX: 0.75,
    pivotHeightY: 0.25,
    shaftRadius: 0.03,
    bladeLength: 0.4,
    bladeWidth: 0.12,
  },
  boat: {
    hullLength: 6,
    hullDepth: 0.2,
    hullThickness: 0.08,
    hullOffsetY: -0.05,
  },
  crew: {
    seats: 1,
    seatSpacing: 0.9,
  },
  camera: {
    initialDistance: 10,
    minPolarAngle: 1.3,
    maxPolarAngle: 1.57,
    minAzimuthAngle: -0.2,
    maxAzimuthAngle: 0.2,
    minDistance: 8,
    maxDistance: 12,
  },
};

export const eightRowerSideViewGeometry: RowerSideViewGeometry = {
  scale: { ...rowerSideViewGeometry.scale },
  waterline: { ...rowerSideViewGeometry.waterline },
  seat: { ...rowerSideViewGeometry.seat },
  oar: { ...rowerSideViewGeometry.oar },
  boat: {
    ...rowerSideViewGeometry.boat,
    hullLength: 17,
  },
  crew: {
    seats: 8,
    seatSpacing: 0.9,
  },
  camera: {
    ...rowerSideViewGeometry.camera,
    initialDistance: 24,
    minDistance: 20,
    maxDistance: 32,
    minAzimuthAngle: -0.12,
    maxAzimuthAngle: 0.12,
  },
};
